"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureStore = exports.handleHot = exports.history = void 0;
var redux_1 = require("redux");
var redux_observable_1 = require("redux-observable");
var connected_react_router_1 = require("connected-react-router");
var history_1 = require("history");
var cookies_1 = require("utils/cookies");
exports.history = (0, history_1.createBrowserHistory)();
var auth_1 = require("@caddigital/sok-reducers/lib/reducers/auth");
// Comboned epics and reducers
var epics_1 = require("../epics");
var reducers_1 = require("../reducers");
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
function actionLogger() {
    return function (next) {
        return function (action) {
            return next(action);
        };
    };
}
var epicMiddleware = (0, redux_observable_1.createEpicMiddleware)();
// Middlewares
var finalCreateStore = composeEnhancers((0, redux_1.applyMiddleware)(epicMiddleware), (0, redux_1.applyMiddleware)((0, connected_react_router_1.routerMiddleware)(exports.history)), (0, redux_1.applyMiddleware)(actionLogger))(redux_1.legacy_createStore);
// Export for testing
var handleHot = function (hmr, store) {
    if (hmr) {
        hmr.accept('../reducers', function () {
            store.replaceReducer(require('../reducers'));
        });
    }
};
exports.handleHot = handleHot;
var getItem = function (key) {
    var value = (0, cookies_1.getCookie)(key);
    if (value && value !== 'undefined') {
        return value;
    }
    return '';
};
var configureStore = function () {
    if (__TOKEN__) {
        (0, cookies_1.setCookie)('token', __TOKEN__, 12);
    }
    var initialState = {
        auth: __assign(__assign({}, auth_1.initialState), { current: __assign(__assign({}, auth_1.initialState.current), { token: __TOKEN__ || getItem('token') }) })
    };
    var store = finalCreateStore(reducers_1.default, initialState);
    epicMiddleware.run(epics_1.default);
    if (__LOCALHOST__) {
        (0, exports.handleHot)(module.hot, store);
    }
    return store;
};
exports.configureStore = configureStore;
